import { render } from "./병원장인사말.vue?vue&type=template&id=8b0b29b2"
import script from "./병원장인사말.vue?vue&type=script&lang=js"
export * from "./병원장인사말.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__